import styled from 'styled-components'

export const Actions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.sp16};
`

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  align-self: stretch;
`

export const GroupHeader = styled.div`
  display: flex;
  height: ${props => props.theme.size.L};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.disabled.surface};
`

export const GroupInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const UsersContainer = styled.div`
  & > div:nth-child(even) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const UserInfoCell = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1 0 0;
`

export const NameAndAlias = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp4};
`

export const EmailCell = styled.div`
  display: flex;
  height: ${props => props.theme.spacing.sp64};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
`

export const GroupCell = styled.div`
  display: flex;
  height: ${props => props.theme.spacing.sp64};
  padding: ${props => props.theme.spacing.sp8} 0;
  justify-content: center;
  align-items: center;
`

export const ActionsCell = styled.div`
  display: flex;
  height: ${props => props.theme.spacing.sp64};
  padding: ${props => props.theme.spacing.sp16};
  justify-content: flex-end;
  align-items: center;
  flex: 1 0 0;
`
